import { PayloadAction } from "@reduxjs/toolkit";
import { LocationsState } from "../../models/LocationsState";
import { DeleteLocationPayload } from "../../payload/DeleteLocation/DeleteLocationPayload";

const deleteLocationFetch = (state: LocationsState, action: PayloadAction<DeleteLocationPayload>) => {
    state.isLoading = true;
}

export default deleteLocationFetch;